export default "__VITE_ASSET__nyIfOAyX__"